import { useEffect } from "react";

export const useKeyboardShortcuts = (
  keyToFunctionMap: Record<string, () => void>,
  deps: any[] = []
) => {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (typeof event.key !== "string") {
        return;
      }

      const { key } = event;
      const keyIdentifier = key.toLowerCase();

      // Special case for Escape key - allow it to work even when input is focused
      if (key === "Escape") {
        const keyFunction = keyToFunctionMap[key];
        if (keyFunction) {
          keyFunction();
          event.preventDefault();
          return;
        }
      }

      // Check if the active element is an input-like element
      const activeElement = document.activeElement;
      const isInputFocused =
        activeElement instanceof HTMLElement &&
        (activeElement.isContentEditable ||
          activeElement.tagName === "INPUT" ||
          activeElement.tagName === "TEXTAREA" ||
          activeElement.tagName === "SELECT");

      // If an input element is focused, don't trigger other shortcuts
      if (isInputFocused) {
        return;
      }

      const keyFunction = keyToFunctionMap[keyIdentifier];
      if (keyFunction) {
        keyFunction();
        event.preventDefault();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [keyToFunctionMap, ...deps]);
};
